import { render } from "./InfoGeneral.vue?vue&type=template&id=20a74970&scoped=true"
import script from "./InfoGeneral.vue?vue&type=script&lang=js"
export * from "./InfoGeneral.vue?vue&type=script&lang=js"

import "./InfoGeneral.vue?vue&type=style&index=0&id=20a74970&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a74970"]])

export default __exports__